/* Reproduce las llamadas encoladas por el shim de theme.liquid.
   Se carga como el ÚLTIMO <script defer> de head-script.liquid:
   al ejecutarse, window.$ ya es el jQuery REAL y todos los plugins cargaron. */
(function () {
  var q = window.__jq || { ready: [], load: [] };
  q.ready.forEach(function (fn) { jQuery(fn); });                 // DOM ya parseado → corre
  q.load.forEach(function (fn) { jQuery(window).on('load', fn); });
  q.ready.length = 0;
  q.load.length = 0;
})();
